export default __webpack_public_path__ + "static/media/rent-banner.de8c3d27.png";